<template lang="pug">
    article#convenios
        //- Banner(nomePagina="Convênios")
        //- Conteudo
        //- Inscricao
</template>

<script>
import pagina from '@/mixins/pagina'
import Banner from '@components/BannerTemplates/BannerTemplates.vue'
import Conteudo from '@sections/Convenios/Conteudo/Conteudo.vue'
import Inscricao from '@components/Inscricao/Inscricao.vue'

export default {
    name: "view-convenios",
    mixins: [
        pagina
    ],
    components: {
        Banner, 
        Conteudo,
        Inscricao
    },
}
</script>

<style lang="stylus" scoped src="./Convenios.styl"></style>